import buttonScrollTop from './scroll-top';

const header = document.querySelector('header');
const scrollTrigger = 60;

window.onscroll = () => {
  if (window.scrollY >= scrollTrigger || window.pageYOffset >= scrollTrigger) {
    header.style.backgroundColor = 'rgb(25, 25, 25)';

    buttonScrollTop.style.display = "block";
  } else {
    header.style.backgroundColor = 'transparent';

    buttonScrollTop.style.display = "none";
  }
};
